const setClickedUrlAction = ({ commit }, payload) => {
  commit('setClickedUrl', payload)
}

export default {
  setClickedUrlAction,
}
